/**
 * <SuggestedActions /> — context-aware example prompts shown in the
 * empty chat state (M22.8).
 *
 * The suggestions adapt to where the user is in the console — on
 * Mission Control you get cross-workflow questions, on a People page
 * you get headcount questions, etc. Every suggestion maps to a
 * read-only capability, so they're all safe for any role (M22 ships
 * no mutations).
 */

const _DEFAULT = [
  "How many employees do we have?",
  "Show me iqamas expiring soon",
  "How do I add a new employee?",
];

function _suggestionsFor(url: string): string[] {
  if (url.startsWith("/mission-control")) {
    return [
      "What approvals are pending today?",
      "Show me compliance alerts",
      "How many employees are on probation?",
    ];
  }
  if (url.startsWith("/people")) {
    return [
      "How many active employees do we have?",
      "Show me non-Saudis with iqamas expiring in 30 days",
      "How do I add a new employee?",
    ];
  }
  if (url.startsWith("/operations")) {
    return [
      "What leave requests are pending approval?",
      "Show me loan applications in progress",
      "How do I terminate an employee?",
    ];
  }
  if (url.startsWith("/policies")) {
    return [
      "What's the basis for the annual leave rule?",
      "How do I configure a leave type?",
      "How do I set up an approval chain?",
    ];
  }
  if (url.startsWith("/reports")) {
    return [
      "What's our headcount breakdown?",
      "Show me the turnover report",
      "Run the compliance dashboard",
    ];
  }
  return _DEFAULT;
}

export function SuggestedActions({
  currentUrl,
  onPick,
}: {
  currentUrl: string;
  onPick: (prompt: string) => void;
}) {
  return (
    <div className="mt-1 flex flex-col gap-1.5">
      {_suggestionsFor(currentUrl).map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onPick(p)}
          className="rounded-lg border border-border-subtle px-2.5 py-1.5 text-start text-xs text-text-secondary hover:border-brand/40 hover:bg-brand/5"
        >
          {p}
        </button>
      ))}
    </div>
  );
}
